import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LoginComponent, LogOutComponent } from '../core';
import { OAuthCallbackComponent, OAuthCallbackHandler } from '../login-callback';
import { PageNotFoundComponent } from '../page-not-found.component';
import { AuthenticationGuard } from '../service';
import { DashboardComponent } from './dashboard/dashboard.component';
import {
  ProductMappingComponent,
  ServiceMappingComponent,
} from './mapping';
import { CategoryMappingComponent } from './mapping/category-mapping/category-mapping.component';
import { CompanyMappingComponent } from './mapping/company-mapping/company-mapping.component';
import { ProcessedSalonCountsComponent } from './mapping/processed-salon-counts/processed-salon-counts.component';
import { UserManagementComponent } from './user-management';
import { UtilityComponent } from './utility.component';
import { SalonTypeMappingComponent } from './mapping/salon-type-mapping/salon-type-mapping.component';
import {
  BarcodeGlobalCompanyPrefixComponent
} from './mapping/barcode-mapping/global-company-prefix/global-company-prefix.component';
import {
  ServiceAndProductMappingCountComponent
} from './mapping/service-and-product-mapping-count/service-and-product-mapping-count.component';
import {CountryMappingComponent} from './mapping/country-mapping/country-mapping.component';
import {
  CountrySubdivisionMappingComponent
} from './mapping/country-subdivision-mapping/country-subdivision-mapping.component';
import {SalonChainMappingComponent} from './mapping/salon-chain-mapping/salon-chain-mapping.component';
import {PostalCodeMappingComponent} from './mapping/postal-code-mapping/postal-code-mapping.component';
import {QuarterMasterMappingComponent} from './mapping/quarter-master-mapping/quarter-master-mapping.component';
import {ProductBarcodeComponent} from './mapping/product-barcode-mapping/product-barcode.component';
import {
  BarcodeToProductMappingComponent
} from './mapping/barcode-to-product-mapping/barcode-to-product-mapping.component';
import { SalonMappingComponent } from './mapping/salon-mapping/salon-mapping.component';

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'logout', component: LogOutComponent },
  { path: 'id_token', component: OAuthCallbackComponent, canActivate: [OAuthCallbackHandler] },
  { path: 'access_token', component: OAuthCallbackComponent, canActivate: [OAuthCallbackHandler] },
  {
	path: 'utility', component: UtilityComponent, canActivate: [AuthenticationGuard], children: [
		// { path: 'data-import', component: DataImportComponent },
		{ path: 'dashboard', component: DashboardComponent },
		{
		path: 'user-management', component: UserManagementComponent
		},
		{
		path: 'service-mapping', component: ServiceMappingComponent
		},
		{ path: 'product-mapping', component: ProductMappingComponent },
		{ path: 'category-mapping', component: CategoryMappingComponent },
		{ path: 'company-mapping', component: CompanyMappingComponent },
		{ path: 'country-mapping', component: CountryMappingComponent },
		{ path: 'country-subdivision-mapping', component: CountrySubdivisionMappingComponent },
		{ path: 'processed-salon-counts', component: ProcessedSalonCountsComponent },
		{ path: 'service-and-product-mapping-count', component: ServiceAndProductMappingCountComponent },
		{ path: 'salon-type-mapping', component: SalonTypeMappingComponent },
		{ path: 'salon-chain-mapping', component: SalonChainMappingComponent },
		{ path: 'barcode-global-company-prefix-mapping', component: BarcodeGlobalCompanyPrefixComponent },
		{ path: 'product-to-barcode-mapping', component: BarcodeToProductMappingComponent },
		{ path: 'product-barcode-assignment', component: ProductBarcodeComponent },
		{ path: 'postal-code-mapping', component: PostalCodeMappingComponent },
		{ path: 'quarter-master-mapping', component: QuarterMasterMappingComponent },
		{ path: 'salon-mapping', component: SalonMappingComponent }
	]
  },
  { path: '**', component: PageNotFoundComponent },
  { path: 'not-allowed', component: PageNotFoundComponent }

];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
})
export class UtilityRoutingModule { }
